import I18n from '../../../i18n-js/index.js.erb';

function statusChangeCallback(response){
  load = true;
  console.log(response);
  if(response.status == "connected"){
    window.location = "/users/facebook/"+response.authResponse.userID+"?accessToken="+response.authResponse.accessToken
  } else if (response.status == "unknown") {
    M.toast({'html': I18n.t("user.loginup.facebook.failed")});
  }
}

let load = false;
function activateFacebook(){
  setTimeout(()=>{
    if(!load)M.toast({'html': I18n.t("user.loginup.facebook.failed")});
  },2000);
  window.onerror = function (message, file, line, col, error) {
     M.toast({'html': message});
     console.log(file +"/"+ line +":"+ col  );
     console.log(error);
     return false;
  };

  window.fbAsyncInit = function() {
    FB.init({
      appId      : '169609464959194',
      cookie     : true,
      xfbml      : true,
      version    : 'v9.0'
    });

    FB.AppEvents.logPageView();

    FB.getLoginStatus(statusChangeCallback, {scope: 'public_profile,email,first_name,last_name,short_name'});

    document.querySelector("#activateFacebook").removeEventListener("click", activateFacebook);
    document.querySelector("#activateFacebook").addEventListener("click",()=>{
      FB.login(statusChangeCallback, {scope: 'public_profile,email,first_name,last_name,short_name'});
    });
  };

  (function(d, s, id){
     let js, fjs = d.getElementsByTagName(s)[0];
     if (d.getElementById(id)) {return;}
     js = d.createElement(s); js.id = id;
     js.src = "https://connect.facebook.net/fr_FR/sdk.js";
     fjs.parentNode.insertBefore(js, fjs);
   }(document, 'script', 'facebook-jssdk'));
}


document.addEventListener('turbolinks:load', ()=>{
  document.querySelector("#activateFacebook").addEventListener("click", activateFacebook);
});
